import { render, staticRenderFns } from "./PartsCRUD.vue?vue&type=template&id=0f08f223&"
import script from "./PartsCRUD.vue?vue&type=script&lang=js&"
export * from "./PartsCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports